import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import { loadFonts } from "./plugins/webfontloader";
import { Amplify } from "aws-amplify";
import { AVPlugin } from "vue-audio-visual";

document.addEventListener("contextmenu", function (e) {
  e.preventDefault();
});

document.addEventListener("keydown", function (e) {
  if (
    (window.location.hostname !== "localhost" && window.location.hostname !== "devbms.quizzr.in") &&
    (e.keyCode === 123 ||
      (e.ctrlKey &&
        e.shiftKey &&
        ["I", "J", "C"].includes(e.key.toUpperCase())) ||
      (e.altKey && e.metaKey && (e.keyCode == 73 || e.keyCode == 67)) ||
      (e.ctrlKey && e.key.toUpperCase() === "U"))
  ) {
    e.preventDefault();
    return false;
  }
});

loadFonts();
async function initApp() {
  Amplify.configure({
    Auth: {
      Cognito: {
        identityPoolId:
          window.location.hostname === "bms.quizzr.in" ||
          window.location.hostname === "www.bms.quizzr.in"
            ? "ap-south-1:58fc7e14-b200-4d05-9088-4386f568acae"
            : "ap-south-1:daa0c036-87c8-40be-882a-cfa1d469f51b",
        userPoolId:
          window.location.hostname === "bms.quizzr.in" ||
          window.location.hostname === "www.bms.quizzr.in"
            ? "ap-south-1_Hhia0FNAL"
            : "ap-south-1_5ca9FnBX2",
        userPoolClientId:
          window.location.hostname === "bms.quizzr.in" ||
          window.location.hostname === "www.bms.quizzr.in"
            ? "57uormvg78qbiim28dujd93jfj"
            : "1sf1didq224afakp7nbfgou43u",
        loginWith: {
          email: true,
        },
        signUpVerificationMethod: "code",
      },
    },
    API: {
      GraphQL: {
        endpoint:
          window.location.hostname === "bms.quizzr.in" ||
          window.location.hostname === "www.bms.quizzr.in"
            ? "https://aegyoabkhzaxlm65cabgqgha3m.appsync-api.ap-south-1.amazonaws.com/graphql"
            : "https://ukfkgf5elrdxld3y6llrarihlu.appsync-api.ap-south-1.amazonaws.com/graphql",
        region: "ap-south-1",
        defaultAuthMode: "userPool",
      },
    },
    Storage: {
      S3: {
        bucket: "quizarre-documents",
        region: "ap-south-1",
      },
    },
  });
}
initApp().then(() => {
  createApp(App)
    .use(router)
    .use(store)
    .use(vuetify)
    .use(AVPlugin)
    .mount("#app");
});
